/* AUTO-GENERATED from Claude Design bundle. Do not edit by hand —
   regenerate via scripts. Faithful port of the ZUZU redesign prototype. */
/* eslint-disable */
import { ZZ_PALETTES, ZZ_PALETTE_MOOD, zzTextureUrl } from './data';
import { SitePage } from './site';
// WebApp (and everything only it reaches - app.jsx/session.jsx/room.jsx) is
// deliberately NOT imported here: ZuzuRedesign.tsx loads it via React.lazy()
// so marketing-site visitors never download the booking-app bundle. Adding
// a static `WebApp` import/export back to this barrel would defeat that
// code-split boundary.
//
// chatbot.jsx (ZuzuChat) is excluded for the same reason — it carries a
// multi-KB system-prompt string plus its own UI/network logic that most
// visitors never open. ZuzuRedesign.tsx loads it via React.lazy() instead.
//
// window.ZZ_UPCOMING is intentionally NOT seeded with a mock default here —
// app.jsx's BookingsScreen and zzHelpers.js's __ZZ_NEXTB() both read it as
// `window.ZZ_UPCOMING || []`, so it's an honest empty list until
// ZuzuRedesign.tsx publishes the real signed-in member's upcoming bookings
// at mount.


/* ====== index.html inline App ====== */


/* ═════════════════════════════════════════════════════
   TWEAKS — palettes, hero layout, photo variant, page,
   app screen, view, etc. The whole demo is driven from
   this single state object.
   ═════════════════════════════════════════════════════ */
const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "view": "site",
  "page": "pricing",
  "appScreen": "today",
  "loggedIn": false,
  "palette": [
    "#834D4E",
    "#E6CDCC",
    "#F4EDE5"
  ],
  "heroLayout": "portal",
  "photoVariant": 0,
  "showAnnounce": true,
  "showLive": true,
  "appInFrame": true,
  "compressionImage": "futon",
  "manifestoTexture": "calm-water",
  "navStyle": "clay",
  "waveStyle": "dune",
  "waveMotion": "flow",
  "parallax": "soft",
  "tedSkin": "water"
}/*EDITMODE-END*/;

const NAV_STYLES = ['ink', 'terracotta', 'clay', 'sage', 'slate', 'rose'];

// zzTextureUrl swaps in the 768w mobile re-encode of each backdrop on phones.
const MANIFESTO_TEXTURES = {
  'slow-sand': `url("${zzTextureUrl('texture-slow-sand.9132862e.webp')}")`,
  'calm-water': `url("${zzTextureUrl('texture-calm-water.ce772b76.webp')}")`,
  'natural-leaf': `url("${zzTextureUrl('texture-natural-leaf.7d68a3ce.webp')}")`,
  'human-terracotta': `url("${zzTextureUrl('texture-human-terracotta.3309cde0.webp')}")`,
};

const PALETTES = ZZ_PALETTES; // 4 palette arrays
const MOODS = ZZ_PALETTE_MOOD; // ['human','natural','slow','calm']
const PALETTE_TO_MOOD = {};
PALETTES.forEach((p, i) => {PALETTE_TO_MOOD[JSON.stringify(p)] = MOODS[i];});

export { SitePage, PALETTES, MOODS, PALETTE_TO_MOOD, MANIFESTO_TEXTURES, NAV_STYLES, TWEAK_DEFAULTS };